<template>
  <div>
      <div  class="shareOnText" v-if="labelOnTop">{{$t('common.labels.shareOn')}} </div>
     <social-sharing :url="shareBaseUrl + item.contentId"  :title="item.title" :description="item.description" :quote="item.title" inline-template>
          <div class="social-links">
               <network network="email">
                    <i class="mdi mdi-email"></i>
               </network>
               <network network="facebook">
                    <i class="mdi mdi-facebook"></i>
               </network>
               <network network="twitter">
                    <i class="mdi mdi-twitter"></i>
               </network>
               <network network="linkedin">
                    <i class="mdi mdi-linkedin"></i>
               </network>
              <!--  <network network="skype">
                    <i class="mdi mdi-skype"></i>
               </network> -->
               <!-- <network network="whatsapp">
                    <i class="mdi mdi-whatsapp"></i>
               </network> -->
          </div>
     </social-sharing>
     <!-- <div  class="shareOnText" v-if="!labelOnTop">{{$t('common.labels.shareOn')}} </div> -->
  </div>
</template>
<script>
import {SHARE_ON_MEDIA_URL} from '@/components/common/constants.js'
export default {
  name: 'shareOnMedia',
  props: ['item', 'labelOnTop'],
  data () {
    return {
      shareBaseUrl: SHARE_ON_MEDIA_URL
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/common/shareOnMedia.vue?38ce4038